import { render, staticRenderFns } from "./LotProductsPanel.vue?vue&type=template&id=227366ba&scoped=true"
import script from "./LotProductsPanel.vue?vue&type=script&lang=ts"
export * from "./LotProductsPanel.vue?vue&type=script&lang=ts"
import style0 from "./LotProductsPanel.vue?vue&type=style&index=0&id=227366ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227366ba",
  null
  
)

export default component.exports